(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.ImgLayer = factory());
}(this, (function () { 'use strict';
/**
 * @author louyanqi
 */
  function ImgOverLayer (map, img_src, point) {
    console.log(map, img_src, point)
    this._map = map
    this._img_src = img_src
    this._point = new BMap.Point(point.lng, point.lat)
    this._div = null
  }

  ImgOverLayer.prototype = new BMap.Overlay();

  ImgOverLayer.prototype.initialize = function(map) {
    this._map = map;
    var div = document.createElement("div");
    div.style.cssText = `
    background: url('${this._img_src}');
    position: absolute;
    z-index: 100;
    width: 40px;
    height: 40px;
    background-position: center;
    background-size: auto 40px;
    border-radius: 5px;
    cursor: pointer;
    `
    map.getPanes().labelPane.appendChild(div);
    this._div = div
    div.addEventListener("click", (e)=>{
      
    });
    return div;
  }

  ImgOverLayer.prototype.draw = function() {
    var map = this._map;
    var pixel = map.pointToOverlayPixel(this._point);
    this._div.style.left = pixel.x - 20 + 'px';
    this._div.style.top  = pixel.y - 20 + 'px';
  }

  ImgOverLayer.prototype.show = function() {
    this._map.addOverlay(this);
  }

  ImgOverLayer.prototype.hide = function() {
    this._map.removeOverlay(this);
  }

  function ImgLayer(map, img_list, base_url) {
    this._map = map
    this._img_list = img_list
    this._overlays = []
    this._base_url = base_url || ''
    this.show()
  }

  ImgLayer.prototype.show = function(){
    this.clear()
    if (!this._img_list){
      return
    }
    for (let i of this._img_list){
      if (!i.thumbnail){
        continue
      }
      var myCompOverlay = new ImgOverLayer(this._map,this._base_url + i.thumbnail, {lng: i.lng, lat: i.lat}, i);      
      // this._map.addOverlay(myCompOverlay)
      this._overlays.push(myCompOverlay)
    }
    // var markerClusterer = new BMapLib.MarkerClusterer(this._map, {markers:this._overlays});
  }

  ImgLayer.prototype.clear = function(){
    for (let i of this._overlays){
      this._map.removeOverlay(i)
    }
  }

  return ImgLayer
})))


// WEBPACK FOOTER //
// ./src/utils/img_overlay.js